import { render, staticRenderFns } from "./FeedbackBox.vue?vue&type=template&id=89e21dd8&scoped=true"
import script from "./FeedbackBox.vue?vue&type=script&lang=js"
export * from "./FeedbackBox.vue?vue&type=script&lang=js"
import style0 from "./FeedbackBox.vue?vue&type=style&index=0&id=89e21dd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e21dd8",
  null
  
)

export default component.exports